import React, { useState, useEffect } from "react";
import { Prompt } from "react-router-dom";

import { Col, Container, Row, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../../Helper/Breadcrumbs";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import axios, { get } from "axios";
import config from "../../../../config";
import moment from "moment";
import Button from "@mui/material/Button";
import _ from "lodash";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DateSelectionModal from "./DateSelectionModal";


const MuhurthaCalandar = () => {
  let breadcrumbData = [
    {
      title: "Masters",
      href: "/masters",
    },
    {
      title: "Muhurtham Calendar",
      href: "/masters/MuhurthaCalandar",
    },
  ];

  let tokenKey = {
    headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
  };

  const currentYear = new Date().getFullYear();
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [valarpiraiDates, setValarpiraiDates] = useState([]);
  const [theipiraiDates, setTheipiraiDates] = useState([]);
  const [years, setYears] = useState([]);
  const [statesData, setstatesData] = useState([]);
  const [selectedState, setcurrentState] = useState("Tamilnadu");
  const [selectedStateId, setSelectedStateId] = useState("41");
  const [isPageLoading, setLoader] = useState(false);
  const [isinitialPageLoading, setInitialPageLoading] = useState(false);
  const [isDataExist, setDataExist] = useState(false);
  const [primaryKey, setPrimarykeyId] = useState(null);
  const [autodata, setAutodata] = useState({ id: 41, name: "Tamilnadu" });

  const [modalOpen, setModalOpen] = useState(false);
  const [clickedDate, setClickedDate] = useState(null);
  const [clickedDateType, setClickedDateType] = useState(null);
  const [isDirty, setIsDirty] = useState(false);



  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  useEffect(() => {
    setLoader(true);
    get(config.service + "/masters/state/", tokenKey)
      .then((res) => {
        setstatesData(res.data);
        setInitialPageLoading(true);
      })
      .catch((err) => {
        if (err.response.status === 401) window.location.href = "/";
      });
    axios
      .get(
        config.service +
          `/booking/muhurtham_calendar?state=Tamilnadu&year=${currentYear}`,
        tokenKey
      )
      .then((response) => {
        setLoader(false);
        if (response.data.data.length > 0) {
          setValarpiraiDates(response.data.data[0].valarpirai_dates || []);
          setTheipiraiDates(response.data.data[0].theipirai_dates || []);

          handleClose();
          setDataExist(true);

          setPrimarykeyId(response.data.data[0].id);
        } else if (response.data.data.length === 0) {
          setValarpiraiDates([]);
          setTheipiraiDates([]);
          setDataExist(false);
          handleClose();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoader(false);
      });
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDirty) {
        const message = "You have unsaved changes. Are you sure you want to leave?";
        e.returnValue = message;
        return message;
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isDirty]);

  const handleClose = () => {
    setLoader(false);
  };
  const handleOpen = () => {
    setLoader(true);
  };

  const onUpdateClick = () => {
    setLoading(true);
    const resourceData = {
      state_id: selectedStateId,
      state: selectedState,
      year: selectedYear,
      valarpirai_dates: valarpiraiDates,
      theipirai_dates: theipiraiDates,
    };
    
    console.log("Updating with ID:", primaryKey);
    axios
      .put(
        `${config.service}/booking/muhurtham_calendar?id=${primaryKey}`,
        resourceData,
        tokenKey
      )
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setLoading(false);
          setIsDirty(false);

          const updatedData = response.data.data;
          setValarpiraiDates(updatedData.valarpirai_dates || []);
          setTheipiraiDates(updatedData.theipirai_dates || []);
          toast("Successfully Updated");
        } else {
          setLoading(false);
          console.error("Failed to update resource:", response.statusText);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Update error:", error);
        toast("Failed to Update !!");
      });
  };

  const onSubmitClick = () => {
    const value = {
      state_id: selectedStateId,
      state: selectedState,
      year: selectedYear,
      valarpirai_dates: valarpiraiDates,
      theipirai_dates: theipiraiDates,
    };
    setLoading(true);
    if ((valarpiraiDates.length !== 0 || theipiraiDates.length !== 0) && selectedState !== "") {
      axios
        .post(config.service + "/booking/muhurtham_calendar", value, tokenKey)
        .then((response) => {
          setLoading(false);
          setIsDirty(false);
          
          const updatedData = response.data.data;
          setValarpiraiDates(updatedData.valarpirai_dates || []);
          setTheipiraiDates(updatedData.theipirai_dates || []);
          setDataExist(true);
          setPrimarykeyId(updatedData.id);
          
          toast("Successfully Added");
        })
        .catch((err) => {
          setLoading(false);
          toast("Can't be Added");
        });
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    setSelectedYear(currentYear);
  }, [currentYear]);

  useEffect(() => {
    const generateYears = () => {
      const yearOptions = [];
      const minOffset = -1;
      const maxOffset = 30;
      for (let i = minOffset; i <= maxOffset; i++) {
        const yearFromSelect = currentYear + i;
        yearOptions.push(yearFromSelect);
      }
      return yearOptions;
    };

    setYears(generateYears());
  }, [selectedYear]);

  const onGet = () => {
    // eslint-disable-next-line no-lone-blocks
    {
      isinitialPageLoading && handleOpen();
    }
    if (selectedState !== null) {
      axios
        .get(
          config.service +
            `/booking/muhurtham_calendar?state=${selectedState}&year=${selectedYear}`,
          tokenKey
        )
        .then((response) => {
          if (response.data.data.length >= 1) {
            setValarpiraiDates(response.data.data[0].valarpirai_dates || []);
            setTheipiraiDates(response.data.data[0].theipirai_dates || []);
            setIsDirty(false);
            setLoader(false);
            setDataExist(true);

            setPrimarykeyId(response.data.data[0].id);
          } else if (response.data.data.length === 0) {
            setValarpiraiDates([]);
            setTheipiraiDates([]);
            setIsDirty(false);
            setDataExist(false);
            handleClose();
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  const handleYearChange = (event) => {
    const year = parseInt(event.target.value);
    setSelectedYear(year);
  };

  const handleDateClick = (month, day) => {
    const formattedDate = new Date(selectedYear, month - 1, day).toString();
    const initialDate = moment(formattedDate);
    const selectedDate = initialDate.format("YYYY-MM-DD");

    const existingType = valarpiraiDates.includes(selectedDate) 
      ? "valarpirai" 
      : theipiraiDates.includes(selectedDate) 
        ? "theipirai" 
        : null;

    if (existingType) {
      // If already selected, remove it
      setValarpiraiDates(valarpiraiDates.filter(d => d !== selectedDate));
      setTheipiraiDates(theipiraiDates.filter(d => d !== selectedDate));
      setIsDirty(true);
    } else {
      setClickedDate(selectedDate);
      setClickedDateType(null);
      setModalOpen(true);
    }
  };

  const handleModalConfirm = (date, type) => {
    if (type === "valarpirai") {
      setValarpiraiDates([...valarpiraiDates, date]);
    } else if (type === "theipirai") {
      setTheipiraiDates([...theipiraiDates, date]);
    }
    setIsDirty(true);
  };

  const isDateSelected = (month, day) => {
    const formattedDate = new Date(selectedYear, month - 1, day).toString();
    const initialDate = moment(formattedDate);
    const selectedDate = initialDate.format("YYYY-MM-DD");

    if (Array.isArray(valarpiraiDates) && valarpiraiDates.includes(selectedDate)) return "valarpirai";
    if (Array.isArray(theipiraiDates) && theipiraiDates.includes(selectedDate)) return "theipirai";
    return null;
  };

  const getDaysInMonth = (year, month) => {
    return new Date(year, month, 0).getDate();
  };

  return (
    <>
      <Prompt
        when={isDirty}
        message="You have unsaved changes. Are you sure you want to leave?"
      />
      <Container className="vendor">

        <Card>
          <CardBody>
            <div className="card__title pageNav">
              <div className="bold-text">
                <Breadcrumbs data={breadcrumbData} />
              </div>
            </div>
            <Row className="formBtnsDiv mar-b-10">
              <Col xs={12} sm={12} md={12} lg={12} xl={4} xxl={4}>
                <Box sx={{ maxWidth: "100%", margin: "0 0 10px 16px" }}>
                  <FormControl variant="standard" sx={{ m: 1, width: "80%" }}>
                    <Autocomplete
                      options={statesData}
                      getOptionLabel={(i) => i.name}
                      id="clear-on-escape"
                      disabled={statesData.length > 0 ? false : true}
                      value={autodata}
                      getOptionSelected={(option, value) =>
                        option.name === value.name
                      }
                      onChange={(event, newValue) => {
                        setcurrentState(newValue.name);
                        setSelectedStateId(newValue.id);
                        setAutodata(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select State"
                          variant="standard"
                        />
                      )}
                    />
                  </FormControl>
                </Box>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2}>
                <Box sx={{ width: "100%", margin: "0 0 10px 16px" }}>
                  <FormControl
                    variant="standard"
                    sx={{ m: 1, minWidth: "80%" }}
                  >
                    <InputLabel
                      htmlFor="yearSelect"
                      id="demo-simple-select-label"
                    >
                      Select Year
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="yearSelect"
                      value={selectedYear}
                      label="Year"
                      onChange={handleYearChange}
                    >
                      {years.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={2}
                xl={2}
                xxl={2}
                className="d-flex flex-row justify-content-center align-items-start"
              >
                <Button
                  className="mt-3"
                  variant="contained"
                  onClick={() => {
                    onGet();
                  }}
                >
                  {" "}
                  Search
                </Button>
              </Col>
              <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                {isDataExist === false ? (
                  <Button
                    className="mt-3"
                    variant="contained"
                    disabled={selectedState === null || selectedYear === ""}
                    onClick={() => {
                      onSubmitClick();
                    }}
                  >
                    {!loading ? (
                      "Add"
                    ) : (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginLeft: 3,
                        }}
                      >
                        {
                          <CircularProgress
                            size={18}
                            style={{ color: "white" }}
                          />
                        }
                        Add
                      </span>
                    )}
                  </Button>
                ) : (
                  <Button
                    className="mt-3"
                    variant="contained"
                    onClick={() => {
                      onUpdateClick();
                    }}
                  >
                    {!loading ? (
                      "Update"
                    ) : (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginLeft: 3,
                        }}
                      >
                        {
                          <CircularProgress
                            size={18}
                            style={{ color: "white" }}
                          />
                        }
                        Update
                      </span>
                    )}
                  </Button>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>

      <div>
        {selectedYear && (
          <div className="calendar-wrapper">
            <div className="calendar-header-info">
              <h2 className="currentYear">{selectedYear} - Muhurtham Calendar</h2>
              <div className="legend">
                <div className="legend-item">
                  <span className="legend-color valarpirai"></span>
                  <span>Valarpirai</span>
                </div>
                <div className="legend-item">
                  <span className="legend-color theipirai"></span>
                  <span>Theipirai</span>
                </div>
              </div>
            </div>
            <div className="calendar">
              <Row className="month-grid">
                {months.map((month) => (
                  <Col key={month} xs={12} sm={12} md={6} lg={4} xl={3} xxl={3}>
                    <div className="month-card">
                      <h3 className="month-name">
                        {new Date(selectedYear, month - 1, 1).toLocaleString(undefined, { month: "long" })}
                      </h3>
                      <div className="days-header">
                        <span>S</span><span>M</span><span>T</span><span>W</span><span>T</span><span>F</span><span>S</span>
                      </div>
                      <div className="content">
                        {/* Add empty spans for padding based on the first day of the month */}
                        {Array.from({ length: new Date(selectedYear, month - 1, 1).getDay() }).map((_, i) => (
                          <span key={`pad-${i}`} className="day empty"></span>
                        ))}
                        {[...Array(getDaysInMonth(selectedYear, month))].map((_, day) => {
                          const status = isDateSelected(month, day + 1);
                          return (
                            <span
                              key={day}
                              className={`day ${status ? `status-${status}` : ""}`}
                              onClick={() => handleDateClick(month, day + 1)}
                            >
                              {day + 1}
                            </span>
                          );
                        })}
                        {/* Fill the remaining cells to ensure 6 rows (42 cells total) */}
                        {Array.from({ length: 42 - (new Date(selectedYear, month - 1, 1).getDay() + getDaysInMonth(selectedYear, month)) }).map((_, i) => (
                          <span key={`empty-fill-${i}`} className="day empty"></span>
                        ))}
                      </div>
                    </div>
                  </Col>

                ))}
              </Row>
            </div>
          </div>
        )}
      </div>
      <DateSelectionModal 
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        selectedDate={clickedDate}
        existingType={clickedDateType}
        onConfirm={handleModalConfirm}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isPageLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div>
        <ToastContainer />
      </div>
      <style>
        {`
      .calendar-wrapper {
        padding: 20px;
        background: #f8f9fa;
        border-radius: 12px;
        margin: 20px 0;
      }
      .calendar-header-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        flex-wrap: wrap;
        gap: 15px;
      }
      .currentYear {
        font-size: 28px;
        font-weight: 700;
        color: #333;
        margin: 0;
      }
      .legend {
        display: flex;
        gap: 20px;
      }
      .legend-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 500;
      }
      .legend-color {
        width: 15px;
        height: 15px;
        border-radius: 4px;
      }
      .legend-color.valarpirai { background-color: #9c27b0; }
      .legend-color.theipirai { background-color: #2196f3; }
      
      .month-grid {
        margin: 0 -10px;
      }
      .month-card {
        background: #fff;
        border-radius: 12px;
        padding: 15px;
        margin-bottom: 25px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.05);
        transition: transform 0.2s;
        min-height: 350px;
        display: flex;
        flex-direction: column;
      }
      .month-card:hover {
        transform: translateY(-5px);
      }
      .month-name {
        font-size: 1.1rem;
        font-weight: 800;
        text-align: center;
        color: #d81b60 !important;
        margin-bottom: 20px;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        padding: 8px;
        background: linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%);
        border-radius: 10px;
        box-shadow: inset 0 1px 3px rgba(0,0,0,0.05);
      }
      .days-header {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        text-align: center;
        font-weight: bold;
        font-size: 12px;
        color: #999;
        margin-bottom: 10px;
      }
      .month-card .content {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        grid-template-rows: repeat(6, 1fr);
        gap: 5px;
        flex: 1;
      }
      .day {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 13px;
        font-weight: 600;
        border-radius: 6px;
        transition: all 0.2s;
        color: #444;
      }
      .day:hover:not(.empty) {
        background-color: #fce4ec;
        color: #e83e8c;
      }
      .day.empty {
        cursor: default;
      }
      .status-valarpirai {
        background-color: #9c27b0 !important;
        color: #fff !important;
      }
      .status-theipirai {
        background-color: #2196f3 !important;
        color: #fff !important;
      }
      `}
      </style>
    </>
  );
};

export default MuhurthaCalandar;
